// src/components/AnimatedSection.jsx
import React from 'react';
import useInView from '../Hook/UseInView';
import '../components/TelephoneFixe/style.css';

const AnimatedSection = ({ id, sectionTitle, direction, items, count, countLabel, openTarifs }) => {
    return (
        <>
            <h2 className="section-title">{sectionTitle}</h2>

            <article
                id={id} // <-- ajout de l'id ici
                className={`hidden-block ${direction === "left" ? "animate-left" : "animate-right"} ${openTarifs ? "with-tarifs" : ""}`}
            >
                {items.map(({ img, alt, title, text }, i) => (
                    <div key={i}>
                        <img src={img} alt={alt} />
                        <h4>{title}</h4>
                        <p>{text}</p>
                    </div>
                ))}

                {count !== undefined && (
                    <div className="compteur_fibre_client">
                        <h3>{count}+</h3>
                        <p>{countLabel}</p>
                    </div>
                )}
            </article>
        </>
    );
};

export default AnimatedSection;
